module.exports = __webpack_public_path__ + "static/media/ordertrack_homepage.9d431abd.png";